export default "__VITE_ASSET__a4059f8a__"